import { Component, Host, h } from '@stencil/core'
import facebook from './assets/facebook.svg'
import instagram from './assets/instagram.svg'
import pinterest from './assets/pinterest.svg'
import youtube from './assets/youtube.svg'

/**
 * Represents the social media information componentn.
 */
@Component({
    tag: 'wf-social-media',
    styleUrl: 'wf-social-media.scss',
    shadow: true,
})
// eslint-disable-next-line require-jsdoc
export class WfSocialMedia {

    /**
     * @inheritDoc
     */
    render() {
        return (
            <Host>
                <div class="title" part="title">Folge uns Online</div>
                <div>Bleibe mit uns verbunden:</div>
                <div class="black">#Weinfreunde</div>
                <div class="logos">
                    <a href="https://www.facebook.com/weinfreunde.de" target="_blank">
                        <img src={facebook} alt="Facebook Logo"/>
                    </a>
                    <a href="https://www.instagram.com/weinfreunde" target="_blank">
                        <img src={instagram} alt="Instagram Logo"/>
                    </a>
                    <a href="https://www.pinterest.de/weinfreunde" target="_blank">
                        <img src={pinterest} alt="Pinterest Logo"/>
                    </a>
                    <a href="https://www.youtube.com/weinfreunde" target="_blank">
                        <img src={youtube} alt="Youtube Logo"/>
                    </a>
                </div>
            </Host>
        )
    }

}
